"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DefaultTitle = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const DefaultTitle = exports.DefaultTitle = (0, _mui.styled)(_mui.Typography, {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'maxLines'
    ])
})((param)=>{
    let { theme, maxLines } = param;
    return {
        margin: theme.spacing(0, 3),
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        lineClamp: maxLines,
        overflow: 'hidden',
        textAlign: 'center',
        WebkitBoxOrient: 'vertical',
        [theme.breakpoints.up('md')]: {
            margin: 0
        }
    };
});
